import { useEffect } from 'react';

export function useBasicExitIntent(onExit: () => void) {
  useEffect(() => {
    function handleMouseOut(e: MouseEvent) {
      // Check if mouse leaves viewport from top (clientY <= 0)
      // or if relatedTarget is null (mouse leaving window)
      if (
        (e.clientY <= 0 || !e.relatedTarget) &&
        sessionStorage.getItem('tzo-exit-intent') !== 'exit'
      ) {
        sessionStorage.setItem('tzo-exit-intent', 'visited');
        onExit();
      }
    }

    document.addEventListener('mouseout', handleMouseOut);

    return () => {
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, [onExit]);

  useEffect(() => {
    sessionStorage.setItem('tzo-exit-intent', 'open');
  }, []);
}
